import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralMuiModal } from './general-mui-modal';

interface OfficeViewerProps {
	open: boolean;
	onClose: () => void;
	documentUrl: string;
	fileName?: string;
}

export const OfficeViewer: React.FC<OfficeViewerProps> = ({
	open,
	onClose,
	documentUrl,
	fileName = 'Document',
}) => {
	const { t } = useTranslation();

	// Create the Office Online viewer URL
	const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(documentUrl)}`;

	const handleDownload = () => {
		// Create a temporary link element to trigger download
		const link = document.createElement('a');
		link.href = documentUrl;
		link.download = fileName;
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleOpenInNewTab = () => {
		window.open(officeViewerUrl, '_blank');
	};

	return (
		<GeneralMuiModal
			maxWidth="xl"
			title={fileName}
			open={open}
			onClose={onClose}
			styles={{
				paperStyle: {
					width: '90vw',
					height: '90vh',
					maxWidth: '1200px',
					maxHeight: '800px',
				},
				contentStyle: {
					padding: 0,
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
				},
			}}
			content={
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						height: '100%',
						justifyContent: 'center',
						alignItems: 'center',
						p: 4,
					}}
				>
					<Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
						{t('officeViewer.title')}
					</Typography>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ mb: 4, textAlign: 'center', maxWidth: '500px' }}
					>
						{t('officeViewer.description')}
					</Typography>
					<Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
						<Button variant="contained" size="large" onClick={handleOpenInNewTab}>
							{t('officeViewer.openInNewTab')}
						</Button>
						<Button
							variant="outlined"
							size="large"
							startIcon={<DownloadIcon />}
							onClick={handleDownload}
						>
							{t('officeViewer.download')}
						</Button>
					</Box>
				</Box>
			}
		/>
	);
};
